import { AboutTheAPI } from './_components/about-the-api'
import { ModeSDK } from './_components/sdk'
import { isUserRepo } from '@basehub/data/replicache/mutators/_public-types'
import { useSelectedTeamAndRepo } from '~/hooks-data/use-selected-team-and-repo'
import { TabContentDefaultWrapper } from '../../tab-content/wrapper'
import { EditorSettingPageTitle } from '../../_components/setting-page-title'
import { useIsExternalVisitor } from '~/hooks-data/use-user-role'
import { ConnectRelInstructions } from './_components/rel'

export const ConnectTab = () => {
  const isVisitor = useIsExternalVisitor()
  const { data } = useSelectedTeamAndRepo()
  const repository = data?.repo
  const team = data?.team
  const readToken = isUserRepo(data?.repo)
    ? data?.repo.tokens.find((t) => t.scope === 'read')
    : null

  if (!repository || !team || isVisitor) return null

  return (
    <TabContentDefaultWrapper fillerChildren size="md">
      <div className="flex flex-col gap-2 mb-8">
        <EditorSettingPageTitle className="!mb-0">
          Connect BaseHub to Your App
        </EditorSettingPageTitle>
        <div className="max-w-[600px] text-sm leading-[19px] text-dark-muted text-pretty">
          Follow these instructions and you'll be ready to go in no time.
        </div>
      </div>
      <div className="flex gap-10 justify-between">
        <div className="overflow-hidden">
          <div className="flex flex-col gap-12">
            {isUserRepo(repository) && repository.rel && (
              <>
                <ConnectRelInstructions
                  token={readToken?.token ?? ''}
                  rel={repository.rel}
                />

                <div className="text-sm leading-[19px] flex items-center gap-4">
                  <span className="w-full h-[1px] bg-dark-border-solid" />
                  <span className="shrink-0 text-dark-muted text-xs">
                    Or do it manually
                  </span>
                  <span className="w-full h-[1px] bg-dark-border-solid" />
                </div>
              </>
            )}

            <ModeSDK
              token={readToken?.token ?? ''}
              teamSlug={team?.slug ?? ''}
              repoSlug={repository?.slug ?? ''}
              commitId={data?.repo?.latestCommit?.id ?? ''}
            />
          </div>
        </div>
        <div className="shrink-0">
          <AboutTheAPI repo={repository} />
        </div>
      </div>
    </TabContentDefaultWrapper>
  )
}
